import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

class InventoryPostingProvider extends HttpRequest {
  getSkusByOrderWarehouseIds (orderWarehouseIds) {
    this.setHeader(getAuthToken())
    return this.post('/order-warehouses/skus', { orderWarehouseIds })
  }

  getSkusByDeliveryNoteCodes (deliveryNoteCodes) {
    this.setHeader(getAuthToken())
    return this.post('/delivery-notes/skus', { deliveryNoteCodes })
  }

  getSkusByWithdrawNoteCodes (withdrawNoteCodes) {
    this.setHeader(getAuthToken())
    return this.post('/withdraw-notes/skus', { withdrawNoteCodes })
  }

  updateReference (docNo, items) {
    this.setHeader(getAuthToken())
    return this.put(`/erp-stock/${docNo}/reference`, { items })
  }

  approveReference (docNo, postingDate) {
    this.setHeader(getAuthToken())
    return this.patch(`/erp-stock/${docNo}/reference/approved?posting-date=${postingDate}`, {})
  }

  postStockAdjustNegative (payload) {
    this.setHeader(getAuthToken())
    return this.post('/stock-adjustments/negative', payload)
  }
}

export default InventoryPostingProvider
